export const DEFAULT_DELAY = 200;
export const DEFAULT_FALLBACK_TIMEOUT_MS = 5000;
export const DEFAULT_ATTEMPTS = Math.floor(DEFAULT_FALLBACK_TIMEOUT_MS / DEFAULT_DELAY);
